import { Transaction } from "@oysterhr/schema"
import { Icon, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { TransactionsTable } from "~/app/components/paymentMethods/TransactionsTable"

interface TransactionsAreaProps {
  transactions: Transaction[]
}

export const TransactionsArea = ({ transactions }: TransactionsAreaProps) => {
  const { t } = useTranslation("components/payment_methods/Transactions")

  return (
    <div
      id="transactions"
      className="mt-5 flex h-full w-full flex-col gap-y-4 rounded-lg border border-gray-100 p-4 md:gap-y-8 lg:mt-0"
    >
      <div className="text-black-base flex items-center">
        <Icon name="ChartLine" />
        <Text className="ml-2 font-semibold">{t("title")}</Text>
      </div>
      <TransactionsTable transactions={transactions} />
    </div>
  )
}
